const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolutionQuickstartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h128v128H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.211 42.166c.777-6.034-3.542-10.985-9.569-10.985H66.408c-6.029 0-11.623 4.952-12.4 10.985L47.795 90.4c-.777 6.033 3.542 10.984 9.57 10.984h48.233c6.029 0 11.623-4.952 12.4-10.984l6.213-48.234Z",
    style: {
      fill: "#fff",
      stroke: "#29b5e8",
      strokeWidth: "6.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.078 87.674-4.655-6.594-4.746.572c-3.215 0-6.271-.716-9.038-2.389-2.646-1.6-4.606-3.813-5.897-6.62-1.397-3.036-1.682-6.296-1.259-9.579.449-3.485 1.669-6.67 3.72-9.528 2.013-2.805 4.542-5.019 7.602-6.62 3.024-1.582 6.24-2.389 9.654-2.389 3.22 0 6.295.703 9.064 2.389 2.632 1.602 4.573 3.816 5.845 6.62 1.374 3.025 1.66 6.261 1.239 9.528-.408 3.169-1.45 6.112-3.184 8.8l-6.414 6.465 7.103 9.345h-9.034ZM74.96 63.064l.579 6.386 3.375 4.232 5.599 1.479 5.954-1.479 4.439-4.232 2.225-6.386-.583-6.361-3.356-4.18-5.576-1.453-5.976 1.453-4.459 4.18-2.221 6.361Z",
    style: {
      fill: "#29b5e8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.23 21.067H85.683c-1.382 0-2.362-1.124-2.184-2.507l.123-.951c.178-1.383 1.447-2.507 2.83-2.507h10.546c1.383 0 2.362 1.124 2.184 2.507l-.122.951c-.178 1.383-1.448 2.507-2.83 2.507",
    style: {
      fill: "#2ab5e8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.805 22.104-1.169 9.077h-5.965l1.169-9.077h5.965Z",
    style: {
      fill: "#2ab5e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.482 49.192-19.214-1.648c-1.721-.037-2.265-.713-2.256-2.041.007-1.088.714-1.928 2.341-1.936l19.129-1.834a3.73 3.73 0 1 1 0 7.459M37.295 67.61 2.694 65.339c-1.72-.038-2.265-.714-2.256-2.041.008-1.088.715-1.928 2.342-1.936l34.515-1.212a3.73 3.73 0 0 1 0 7.46M34.764 86.989 10.938 85.03c-1.721-.038-2.266-.714-2.256-2.041.007-1.088.714-1.928 2.341-1.936l23.741-1.523a3.73 3.73 0 1 1 0 7.459",
    style: {
      fill: "#2ab5e8",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionQuickstartIcon);
export default __webpack_public_path__ + "static/media/Solution_quickstart_icon.f18276d251d7a895e878328857fe6541.svg";
export { ForwardRef as ReactComponent };